<template>
  <el-dialog
    :visible.sync="isShown"
    title="シフト適用">
    <div>
    {{ year }}年{{ month }}年の&nbsp;<b>{{ shopData.name }}</b>&nbsp;の予定を適用します．<br />
    店長確認 がONになっている予定がシフトとして登録されます．<br />
    <span style="color: red;">適用した日付の予定は変更できなくなります．</span><br />
    <span style="color: red;">既にシフトが入力されている場合，予定で上書きされます．</span><br />
    </div>
    <div style="margin-top: 30px;">
      店名を確認の上，確認コード「<b>{{ confirmCode }}</b>」を入力し，適用ボタンを押してください．
    </div>
    <el-form inline>
      <el-form-item label="確認コード">
        <el-input v-model="form.confirmCode"></el-input>
      </el-form-item>
    </el-form>
    <error-list :errors="errors.nonFieldErrors" />
    <div slot="footer">
      <el-button v-loading="sending" :disabled="confirmCode !== form.confirmCode" @click="applyShiftPlan" type="danger">適用</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ErrorList from '@/parts/ErrorList'

export default {
  name: 'ShiftApplyDialog',
  components: {
    ErrorList,
  },
  data () {
    return {
      isShown: false,
      sending: false,
      confirmCode: '',
      form: {
        confirmCode: '',
      },
      errors: {
        nonFieldErrors: [],
      },
      year: null,
      month: null,
      shopData: {
        pk: null,
        name: '',
      },
    }
  },
  methods: {
    show (year, month, shopData) {
      this.isShown = true
      this.year = year
      this.month = month
      this.setConfirmCode()
      Object.keys(this.shopData).forEach(key => {
        this.shopData[key] = shopData[key]
      })
    },
    hide () {
      this.isShown = false
    },
    resetError () {
      Object.keys(this.errors).forEach(key => {
        this.errors[key] = []
      })
    },
    applyShiftPlan () {
      this.sending = true
      this.resetError()
      this.$request.shifts.planApply(this.shopData.pk, this.year, this.month).then(res => {
        console.log(res)
        this.$message('入力されていた予定をシフトに適用しました')
        this.$emit('applied', res.body.applied)
        this.hide()
      }, err => {
        this.$err400(err)
      }).finally(() => {
        this.sending = false
      })
    },
    setConfirmCode () {
      let c = '0123456789'
      let cl = c.length
      let r = ''
      for (let i = 0; i < 4; i++) {
        r += c[Math.floor(Math.random() * cl)]
      }
      this.confirmCode = r
      this.form.confirmCode = ''
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/ShiftPlan/ShiftApplyDialog.vue